"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpponentInput = OpponentInput;
var _react = _interopRequireDefault(require("react"));
var _client = require("@apollo/client");
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _material = require("@mui/material");
var _reactHookForm = require("react-hook-form");
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Q_TEAMS = (0, _client.gql)`
  subscription opponents {
    teams(where: {active: {_eq: true}}, order_by: {name: asc_nulls_last}) {
      id
      name
    }
  }
`;
function OpponentInput({
  control,
  field,
  errors
}) {
  const {
    data
  } = (0, _client.useSubscription)(Q_TEAMS);
  const hasError = Boolean(errors) && Boolean(errors[field]);

  // const opponents = [{label: 'Team 1', id: 1}]

  const opponents = data?.teams.map(team => ({
    label: team.name,
    id: team.id
  })) || [];

  // const handleFocus = (e) => {
  //   getOpponents()
  // }

  return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: field,
    control: control,
    render: ({
      field: {
        onChange: handleChange,
        value = '',
        ...rest
      }
    }) => {
      return /*#__PURE__*/_react.default.createElement(_FormControl.default, _extends({
        size: "small"
      }, hasError ? {
        error: true
      } : {}), /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
        id: "opponent"
      }, "Opponent"), /*#__PURE__*/_react.default.createElement(_Select.default, {
        labelId: "opponent",
        id: "opponent-select",
        value: value,
        label: "Opponent"
        // onFocus={handleFocus}
        ,
        onChange: handleChange,
        sx: {
          width: 142
        }
      }, opponents.map(opponent => /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        key: opponent.id,
        value: opponent.id
      }, opponent.label))), hasError ? /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, errors[field].message) : null);
    }
  });
}